const compareDates = (a, b) => {
  if (a === null && b === null) {
    return 0
  }

  if (a === null) {
    return -1
  }

  if (b === null) {
    return 1
  }

  const dateA = new Date(a)
  const dateB = new Date(b)

  if (dateA === dateB) {
    return 0
  }

  return dateA < dateB ? -1 : 1
}

export default compareDates
